import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import SettingsPanelSection from '../SettingsPanelSection';
import { connect } from 'react-redux';
import ImageIcon from '@mui/icons-material/ImageRounded';
import LogoMediaPickerDialog from '../../MediaPickers/LogoMediaPickerDialog';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import { VISUALIZER_SHAPE } from '../../Preview/PreviewDisplayConstants';
import { mediaPickerActions } from '../../MediaPickers/store';
import { createActions } from '../../store';
import SettingsPanelVisualizerSubTabContent from './SettingsPanelVisualizerSubTabContent';

const styles = theme => ({
    tabsContainer: {
        background: theme.palette.action.hover,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '& .MuiTabs-indicator': {
          display: 'none',
        },
    },
    tab: {
        minWidth: 0,
        transition: theme.transitions.create('background', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shortest,
        }),
        '&:hover': {
            background: theme.palette.action.hover
        },
        '&.Mui-selected': { 
            color:"white",
            background: theme.palette.action.selected,
            fontWeight: 500
    },
        textTransform: 'none',
        fontSize: 15,
        fontWeight: 400
    }
});

const SettingsPanelSectionVisualizer = ({ classes, openLogoPicker, visualizerShape, requestedSubTab, clearRequestedSubTab }) => {
    const [visualizerTabValue, setVisualizerTabValue] = useState(0);
    const shapeIsCircle = visualizerShape === VISUALIZER_SHAPE.CIRCLE;

    // The Features panel deep links request a specific sub-tab; apply it once and clear
    // the request so normal tab navigation stays local to this component.
    useEffect(() => {
        if (requestedSubTab === null || requestedSubTab === undefined)
            return;

        setVisualizerTabValue(requestedSubTab);
        clearRequestedSubTab();
    }, [requestedSubTab, clearRequestedSubTab]);

    return (
        <SettingsPanelSection
            title='Visualizer'
            action={shapeIsCircle &&
                <CircleProgressButton
                    variant='outlined'
                    color='inherit'
                    startIcon={<ImageIcon />}
                    size='small'
                    onClick={openLogoPicker}
                >
                    Change Logo
                </CircleProgressButton>
            }
        >
            <Tabs
                variant='fullWidth'
                value={visualizerTabValue}
                onChange={(e, newValue) => setVisualizerTabValue(newValue)}
                className={classes.tabsContainer}
            >
                <Tab
                    label='Layers'
                    className={classes.tab}
                    id='visualizer-layers-tab'
                    aria-controls='visualizer-layers-panel'
                />
                <Tab
                    label='Shape'
                    className={classes.tab}
                    id='visualizer-appearance-tab'
                    aria-controls='visualizer-appearance-panel'
                />
                <Tab
                    label='Motion'
                    className={classes.tab}
                    id='visualizer-movement-tab'
                    aria-controls='visualizer-movement-panel'
                />
                <Tab
                    label='Effects'
                    className={classes.tab}
                    id='visualizer-effects-tab'
                    aria-controls='visualizer-effects-panel'
                />
            </Tabs>
            <SettingsPanelVisualizerSubTabContent tabValue={visualizerTabValue} />
            <LogoMediaPickerDialog />
        </SettingsPanelSection>
    );
}

const mapStateToProps = (state) => {
    const { shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    const { visualizerPanelRequestedTab: requestedSubTab } = state.create;
    return { visualizerShape, requestedSubTab };
}

const mapDispatchToProps = (dispatch) => {
    const openLogoPicker = () => dispatch(mediaPickerActions.setProperty('logoMediaPickerOpen', true));
    const clearRequestedSubTab = () => dispatch(createActions.setProperty('visualizerPanelRequestedTab', null));
    return { openLogoPicker, clearRequestedSubTab };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(SettingsPanelSectionVisualizer, styles));